import { Typography } from 'fronton-react';
import React from 'react';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { FileUploadDropzoneProps } from '../types';
import {
  inputContainer,
  dropzoneCapLeftContent,
  dropzoneCapLeftCaption,
} from './dropzone-caption-left.styles';
import { DropzoneIcon } from './dropzone-icon';
import { dropzoneNoLabel } from './dropzone-common.styles';

export const DropzoneCaptionLeft: React.FC<FileUploadDropzoneProps> = ({
  inputProps,
  onFilesSelect,
  ...htmlProps
}) => {
  const { t } = useTranslation();
  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      onFilesSelect?.(acceptedFiles);
    },
    [onFilesSelect],
  );

  return (
    <div className={dropzoneCapLeftContent} {...htmlProps}>
      <Dropzone onDrop={onDrop}>
        {({ getInputProps, getRootProps }) => (
          <div
            {...getRootProps({
              className: dropzoneNoLabel,
              // eslint-disable-next-line i18next/no-literal-string
              'data-anchor': 'dropzone',
            })}
          >
            <DropzoneIcon />
            <div className={inputContainer}>
              <input {...getInputProps(inputProps)} />
            </div>
          </div>
        )}
      </Dropzone>

      <Typography className={dropzoneCapLeftCaption} variant="caption">
        {t('ui.dropzone.click-to-add')}
      </Typography>
    </div>
  );
};
